import { Description, Url } from '../components/TicketOfferings';
import { SanityImage } from '../components/BuyTickets/types';

type Ticket = {
  title: string;
  url: Url;
  image: SanityImage;
  description: Description[];
  slugId: string;
};

export type TicketOffering = {
  title: string;
  tickets: Ticket[];
};

type TicketOfferingsArray = TicketOffering[];

export function getIncludedTicketsArray(
  ticketOfferings: TicketOfferingsArray,
  queryData: any,
) {
  const seenTickets = new Set();
  const includedTickets = ticketOfferings
    .flatMap((offering: TicketOffering) =>
      offering.tickets.map((ticket: Ticket) => {
        const foundTicket = queryData.includedTickets.find(
          (includedTicket: Ticket) => {
            return includedTicket.slugId === ticket.slugId;
          },
        );
        if (foundTicket && !seenTickets.has(ticket.slugId)) {
          seenTickets.add(ticket.slugId);
          return { ...ticket, order: foundTicket.order || 0 };
        }
        return null;
      }),
    )
    .filter(Boolean);

  return includedTickets.sort((a: any, b: any) => a.order - b.order);
}
